import { useEffect, useState } from "react"
import { Box, Chip, Grid, Typography } from "@mui/material"
import { ButtonBasic, TableBase } from "../../components"
import { showModal } from "react-redux-modal-provider";
import { useNavigate } from "react-router-dom";
import KmzService from "../../services/kmz.service";
import ModalCargarKmzFO from "../../modals/fibraOptica/ModalCargarKmzFO";

const TablaFONapsScreen = () => {
    const [items, setItems] = useState([]);
    const navigate = useNavigate()
    const actualizar = async() =>{
        await KmzService.obtenerNapsFO().then((resp)=>{
            setItems(resp);
        }).catch(()=>{
            navigate('/')
        })
    }

    const columns = [
        /* {
            name: "id_fnap",
            label: "ID",
            options: {
                filter: false,
                sort: false,
                display:false,
                viewColumns: false
            }
        }, */
        {
            name: "nombre",
            label: "Nombre",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "metros",
            label: "Radio",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "puertos",
            label: "Cant. Puertos",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "usados",
            label: "Puertos Ocupados",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "latitud",
            label: "Latitud",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "longitud",
            label: "Longitud",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: 'estado',
            label: "Estado",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if(value === 'DISPONIBLE'){
                    return <Chip label="DISPONIBLE" color="success" />
                    }
                    return <Chip label="NO DISPONIBLE" color="error" />
                }
            }
        },
    ];
    const onGuardar = () => actualizar();

    const onOpenEditar = () => {
        showModal(ModalCargarKmzFO, { onGuardar: onGuardar});
    };

    useEffect(() => {
        actualizar();
        document.title = `Naps FO`;
    }, [])

    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto'}} className='side'>
            <Grid container p={3} display='flex' justifyContent='center'>
                <Grid item xs={12}>
                    <Typography className="text-gray-900 font-bold" variant="h2">Naps FO</Typography>
                </Grid>
                {/* <Grid item xs={6} sx={{display: 'flex', justifyContent: 'end'}}>
                    <ButtonBasic
                        textButton="Subir KMZ"
                        sx={{width: 200, height: 30}}
                        onClick={()=>onOpenEditar()}
                        variant='wk'
                        color="nextStep"
                    />
                </Grid> */}
                <Grid item xs={12} md={12} mt={2} sx={{marginBottom: 15}}>
                    <TableBase title='Resultados' columns={columns} data={items} />
                </Grid>
            </Grid>
        </Box>
    )
}

export default TablaFONapsScreen